import { useEffect, useState } from 'react';
import { getProofOfAccount } from '@/services/wallet';
import { TRsGetProofOfAccount } from '@/services/types/WalletData';
import { ResponseBody } from '@/services/types/ResponseBody';

type TState = {
  data: ResponseBody<TRsGetProofOfAccount> | null;
  isLoading: boolean;
  isError: boolean;
};

export const useProofOfAccount = (walletId: string) => {
  const [state, setState] = useState<TState>({ data: null, isLoading: false, isError: false });

  useEffect(() => {
    if (!walletId) return;
    setState({ data: null, isLoading: true, isError: false });
    getProofOfAccount(walletId)
      .then((res) => setState({ data: res, isLoading: false, isError: false }))
      .catch(() => setState({ data: null, isLoading: false, isError: true }));
  }, [walletId]);

  return state;
};
